module.exports = __webpack_public_path__ + "static/media/unbookmark.13119ad0.svg";